import { render, staticRenderFns } from "./TurmasProfessor.vue?vue&type=template&id=e67ae130&"
import script from "./TurmasProfessor.vue?vue&type=script&lang=js&"
export * from "./TurmasProfessor.vue?vue&type=script&lang=js&"
import style0 from "./TurmasProfessor.vue?vue&type=style&index=0&id=e67ae130&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports